import Maska from 'maska';
import Emitter from 'tiny-emitter';
import VCalendar from 'v-calendar';
import { createApp } from "vue";
import App from "./App.vue";
import Closable from './directives/Closable';
import router from "./router";
import { instalarRenovacaoDeSessao } from './services/clients/RenovacaoDeSessao';
import { store } from "./store";
import Vue from 'vue';

import 'v-calendar/dist/style.css';


// jwt expirado deixa de derrubar as telas: 401 renova a sessão e repete a chamada
instalarRenovacaoDeSessao();

const app = createApp(App);

app.config.globalProperties.$msalInstance = {};
// TODO: make the emitter a service
app.config.globalProperties.$emitter = new Emitter();

app.use(store).use(Maska).
  use(VCalendar).
  directive('closable', Closable()).directive('closableonmount', Closable(true)).use(router).mount("#app");

